module.exports = __webpack_public_path__ + "img/teapot.2d99707a.png";